import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import EventRegistration from './EventRegistration';

const EventRegistrationPage: React.FC = () => {
  const { eventId } = useParams<{ eventId: string }>();
  const navigate = useNavigate();

  if (!eventId) {
    return (
      <div>
        <div style={{ marginBottom: '20px' }}>
          <button onClick={() => navigate('/events')} className="btn btn-secondary">
            ← Back to Events
          </button>
        </div>
        <div className="error-container">
          <h2>❌ Missing Event ID</h2>
          <p>Unable to load event registration without an event ID.</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div style={{ marginBottom: '20px' }}>
        <button onClick={() => navigate(`/events/${eventId}`)} className="btn btn-secondary">
          ← Back to Event
        </button>
      </div>
      
      <div className="card">
        <h1>📝 Register for Event</h1>
        <p style={{ color: '#666', marginBottom: '30px', fontSize: '16px' }}>
          Register for this hackathon event to join the participant pool. Once registered, 
          you can create a team, join an existing team, or be discovered by other participants 
          looking for team members.
        </p>
        
        <EventRegistration 
          eventId={eventId}
          onRegistrationChange={() => {
            // Optionally refresh or show additional feedback
            console.log('Registration status changed');
          }}
        />
        
        <div style={{ 
          marginTop: '30px',
          padding: '20px',
          background: '#f8f9fa',
          borderRadius: '8px',
          border: '1px solid #dee2e6'
        }}>
          <h3 style={{ margin: '0 0 15px 0', color: '#333' }}>What's Next?</h3>
          <p style={{ margin: '0 0 15px 0', color: '#666' }}>
            After registering, you can:
          </p>
          <ul style={{ margin: '0', paddingLeft: '20px', color: '#666' }}>
            <li>Create a new team and invite others to join</li>
            <li>Browse existing teams that are looking for members</li>
            <li>Wait to be discovered by team leaders based on your skills</li>
          </ul>
          
          <div style={{ 
            marginTop: '20px', 
            display: 'flex', 
            gap: '10px', 
            flexWrap: 'wrap' 
          }}>
            <button 
              onClick={() => navigate('/join-event')} 
              className="btn"
              style={{ fontSize: '14px', padding: '8px 16px' }}
            >
              🚀 Continue to Team Options
            </button>
            <button 
              onClick={() => navigate('/teams?filter=looking')} 
              className="btn btn-secondary"
              style={{ fontSize: '14px', padding: '8px 16px' }}
            >
              👥 Browse Teams
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventRegistrationPage;
